/**
 * Format time string to French format: '09:00' -> '9h00'
 */
export function formatTime(timeStr) {
  if (!timeStr) return '';
  const [hours, minutes] = timeStr.split(':').map(Number);
  const h = hours === 0 ? '0' : String(hours);
  const m = String(minutes).padStart(2, '0');
  return `${h}h${m}`;
}

/**
 * Convert time string to minutes since midnight: '09:30' -> 570
 */
export function timeToMinutes(timeStr) {
  if (!timeStr) return 0;
  const [hours, minutes] = timeStr.split(':').map(Number);
  return hours * 60 + minutes;
}

/**
 * Convert minutes since midnight to time string: 570 -> '09:30'
 */
export function minutesToTime(minutes) {
  const h = Math.floor(minutes / 60) % 24;
  const m = minutes % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

/**
 * Get number of 30-min slots a duration occupies
 */
export function getSlotSpan(duration) {
  return Math.max(1, Math.ceil(duration / 30));
}

/**
 * Generate all 48 time slots (every 30 min)
 */
export function generateTimeSlots() {
  const slots = [];
  for (let h = 0; h < 24; h++) {
    slots.push(`${String(h).padStart(2, '0')}:00`);
    slots.push(`${String(h).padStart(2, '0')}:30`);
  }
  return slots;
}

const FRENCH_MONTHS = [
  'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
  'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre',
];

/**
 * Format a date string (YYYY-MM-DD) as "d mois" in French, e.g. "16 février"
 */
export function formatDateFr(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr + 'T00:00:00');
  return `${d.getDate()} ${FRENCH_MONTHS[d.getMonth()]}`;
}

/**
 * Format a week range as "d mois - d mois" using the start_date.
 * End date is start_date + 6 days.
 */
export function formatWeekRangeFr(startDate) {
  if (!startDate) return '';
  const start = new Date(startDate + 'T00:00:00');
  const end = new Date(start);
  end.setDate(end.getDate() + 6);
  return `${start.getDate()} ${FRENCH_MONTHS[start.getMonth()]} – ${end.getDate()} ${FRENCH_MONTHS[end.getMonth()]}`;
}

/**
 * Extract year from a date string (YYYY-MM-DD)
 */
export function getYearFromDate(dateStr) {
  if (!dateStr) return '';
  return dateStr.substring(0, 4);
}

/**
 * Get the day-of-month number from a date string offset by dayId (1-based)
 */
export function getDayNumber(startDate, dayId) {
  if (!startDate) return '';
  const d = new Date(startDate + 'T00:00:00');
  d.setDate(d.getDate() + (dayId - 1));
  return d.getDate();
}

/**
 * Trigger download of JSON data as file
 */
export function downloadJSON(data, filename = 'grille-export.json') {
  const blob = new Blob([JSON.stringify(data, null, 2)], {
    type: 'application/json',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
